var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalProtections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 18.715V70c0 5.523-4.477 10-10 10H49.123c-11.731-5.47-16.867-17.202-17.581-28.366a26.138 26.138 0 01-.108-2.057c.027-.34.04-.68.055-1.029.013-.334.026-.674.053-1.028C32.516 32.288 41.72 16 64.677 16h.758c5.665 0 10.492.992 14.565 2.715z",
    fill: "#FE98B7",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dLegal)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 64.668c-.016 2.164-5.9 4.561-12.709 4.561-6.808 0-12.49-2.39-12.582-4.561-.317-7.53 5.772-3.29 12.582-3.29 6.81 0 12.772-5.377 12.71 3.29z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.62 61.376c0 2.166-5.521 4.561-12.33 4.561-6.808 0-12.33-2.389-12.33-4.561 0-2.173 5.52-3.29 12.33-3.29 6.81 0 12.33 1.125 12.33 3.29z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.216 60.52c-.012 1.69-4.6 3.553-9.913 3.553-5.312 0-9.74-1.867-9.815-3.552-.247-5.873 4.503-2.567 9.815-2.567 5.312 0 9.963-4.193 9.913 2.567z",
    fill: "#FE98B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.919 57.538c0 1.889-4.305 3.97-9.617 3.97-5.312 0-9.618-2.073-9.618-3.97 0-1.898 4.306-2.866 9.618-2.866s9.617.975 9.617 2.866zM55.99 24.005s1.82 2.007 2.132 4.263c.313 2.255-8.89 5.72-8.89 5.72s-3.193-1.866-3.3-3.614c0 0 6.11-6.569 10.058-6.37z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25 28.958l5.235 8.731-5.325 4.525-4.15.777-1.296-2.337-3.644-6.763 9.18-4.933z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.555 36.83s3.536 3.759 2.628 5.791c-.908 2.032-5.702 6.104-8.754 5.484-3.053-.62-3.542-5.123-3.542-5.123l9.668-6.152zM23.337 53.35l27.082-16.48s2.574.334 2.294 3.782L25.89 57.31a2.774 2.774 0 01-1.83.394c-.733-.1-1.602-.367-1.884-1.065a2.365 2.365 0 01-.149-.554 2.735 2.735 0 011.31-2.735z",
    fill: "#F5F4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.246 27.729a.665.665 0 01.608.502c.132.466-.11.914-.365 1.287a6.916 6.916 0 01-1.679 1.717c-1.102.799-2.172 1.699-3.42 2.281a10.44 10.44 0 01-2.255.711c-.581.134-1.177.2-1.773.195a.522.522 0 01-.322-.922 2.62 2.62 0 01.908-.382c1.614-.475 3.109-1.298 4.508-2.233a14.114 14.114 0 002.107-1.659c.432-.427.983-1.514 1.683-1.497zm4.322 8.434s2.657-.064.458 2.609c-2.2 2.673-6.133 5.325-8.933 4.726 0 0-1.16-.963-.157-1.128.951-.158 5.388-1.037 7.428-3.511a5.3 5.3 0 01.744-.734c.479-.39 1.123-1.128.46-1.962z",
    fill: "#FE98B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9 42.052c.569.949-1.26 3.093-4.085 4.789-2.824 1.696-5.575 2.302-6.144 1.353-.57-.949 1.26-3.092 4.084-4.788 2.825-1.696 5.576-2.302 6.145-1.354z",
    fill: "#F5F4F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dLegal",
    x: 21,
    y: 22,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalProtections);
export default __webpack_public_path__ + "static/media/legal-protections.7991da9be0bf5a923a03941a9bd1d0b9.svg";
export { ForwardRef as ReactComponent };